import { Component, OnInit, OnDestroy } from '@angular/core';
import { Utility } from '../../../common/utility';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DialogService } from './../../../shared/services/dialog.service';
import { AdministerVaccineService } from './administer-vaccine.service';
import { BaseConsultationComponent } from '../base-consultation/base-consultation.component';
import { ConsultationProcessService } from '../consultation-process.service';
import { ConsultationStep } from '../../../models/consultation/consultation.model';
import { GenderType, PatientVaccineVisit } from '../../../models/consultation/patient.model';
import { Page } from '../../../models/list/page.model';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { AdministerVaccineModel } from '../../../models/consultation-process/administer-vaccine.model';
import { AdministerVaccinePopupComponent } from './administer-vaccine-popup.component';
import { SharedService } from '../../../shared/services/share.services';
import { ManageVaccineAddPopupComponent } from '../../centre/manage-vaccine/manage-vaccine-add-popup.component';
import { ValidationService } from '../../../shared/services/validation.service';

@Component({
  selector: 'administer-vaccine',
  templateUrl: 'administer-vaccine.component.html',
  providers: [AdministerVaccineService]
})
export class AdministerVaccineComponent extends BaseConsultationComponent implements OnInit, OnDestroy {
  public appConstants = AppConstants;
  public isFemale = false;
  public administerVaccineModel: Array<AdministerVaccineModel>;
  public valuePregnancy = null;
  public dateEntrySubscription: any;
  public consultationStep: any;
  public page = new Page();
  public siteVaccineData = [];
  public dataRow = [];
  public selectPregnancy = [];
  public dataDateVaccines = [];
  public isSelectPregnanct = true;
  public patientVaccineVisit = PatientVaccineVisit;
  public prescribeVaccination = [];
  public pregnancySelected: any;
  //public pregnancyIdSelected = null;
  public currentDate = new Date();
  public hightLightObj = { isPregnant: false, hightLightArr: [] };
  constructor(public dialogService: DialogService,
    public consultationProcessService: ConsultationProcessService,
    public router: Router,
    public activeRouter: ActivatedRoute,
    public utility: Utility,
    private sharedService: SharedService,
    private administerVaccineService: AdministerVaccineService) {
    super(dialogService, consultationProcessService, router, activeRouter, ConsultationStep.AdministerVaccine);
    // get menu toggle action from shareService
    this.menuSubscription = this.sharedService.getMenuToggle().subscribe(
      data => {
        this.updateTableLayout();
      });
    // get data entry service
    this.dateEntrySubscription = this.sharedService.getDataEntryUpdate().subscribe(
      data => {
        this.updateDataEntryMode(data);
      });
  }

  ngOnInit() {
    this.currentDate.setHours(0, 0, 0);
    this.isDataEntryMode = this.isInDataEntryMode();
    this.page.size = 5;
    this.setPage({ offset: 0 });
    this.administerVaccineService.getSiteVaccineData().subscribe(
      (result) => {
        if (result) {
          this.siteVaccineData = result.json();
        }
      }
    );
    this.consultationProcessService.getPatientData(this.filterParam.patientId).subscribe(
      (result) => {
        if (result) {
          const patientDetail = result.json();
          this.initPrenancyData(patientDetail.sexId);
        }
      }
    );
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
    this.dateEntrySubscription.unsubscribe();
  }

  setHightLight(vaccineObj, index) {
    return {
      vaccineId: vaccineObj.vaccineId,
      isHighLight: vaccineObj.isHighLight,
      index: index
    };
  }

  setPage(pageInfo) {
    this.administerVaccineService.getDataVaccine(this.filterParam.id).subscribe(
      (result) => {
        this.prescribeVaccination = result.json();
        let coveredDate;
        this.prescribeVaccination.forEach((i, index) => {
          coveredDate = '';
          if (i.vaccine.vaccineDates.filter(c => c.isChecked && c.visit === this.patientVaccineVisit.Current).length > 0) {
            // add tooltip for covered vaccine CR01
            if (i.vaccine['isCovered']) {
              coveredDate = 'Covered left – ' + this.utility.convertDateToLocalString(new Date(i.vaccine['expectedCoverDate']), 'DD MMM YYYY');
            }
            i.vaccine['tooltip'] = coveredDate;
            this.dataRow.push(i.vaccine);
            this.hightLightObj.hightLightArr.push(this.setHightLight(i.vaccine, index));
          }
        });
        if (this.prescribeVaccination.length > 0) {
          this.dataDateVaccines = this.createVaccineDateRange(this.prescribeVaccination[0].vaccine.vaccineDates);
        }
        // set default current date for data entry mode
        this.updateProposeAdministerDate();

      }
    );
    this.page.pageNumber = pageInfo.offset;
  }



  createVaccineDateRange(dateArr) {
    let dateRange = [];
    for (let i = 0; i < dateArr.length; i++) {
      if (dateArr[i].date != null) {
        dateArr[i].visitDate = new Date(dateArr[i].visitDate);
        dateRange.push(dateArr[i]);
      }
    }
    return dateRange;
  }


  /**
   * function check gender Female and Male
   */
  initPrenancyData(sexId) {
    // if gender female hidden select pregnancy
    if (sexId === GenderType.Female) {
      // gender = Female then disable all administer and hidden select pregnanchy
      this.administerVaccineService.getSelectPregnancy(this.filterParam.patientId, this.filterParam.id).subscribe(
        (result) => {
          if (result) {
            this.selectPregnancy = result.json();
            const medicalselected = this.selectPregnancy.find(x => x.isSelected === true);
            if (medicalselected) {
              this.valuePregnancy = medicalselected.id;
              this.isSelectPregnanct = true;
              this.InitHighLight(this.valuePregnancy);
              // this.valuePregnancy = medicalselected.id;
            }
          }
        }
      );
      this.isFemale = true;
      this.isSelectPregnanct = false;
    }
  }
  // move Prescribe Vaccination and save data current
  onMovePrescribeVaccination() {
    this.router.navigate(['consultation-process/prescribe-vaccination', this.filterParam.id, this.filterParam.patientId],
      {
        queryParams:
          {
            isEdit: true
          }
      });
  }
  /**
   * @param event
   *  function check valid select prenancy
   */
  onSelectPrenancy(event) {  // Select Prenancy and check valid Prenancy
    const value = event.target.value;
    this.InitHighLight(value);
  }

  InitHighLight(value) {
    this.valuePregnancy = value;
    if (value === null || value === undefined || value === 'null') {
      // if null  disable administer
      this.isSelectPregnanct = false;
    } else {
      this.isSelectPregnanct = true;
      this.pregnancySelected = this.selectPregnancy.find(x => x.id === this.valuePregnancy);
    }
    if (this.isSelectPregnanct) {
      const index = this.selectPregnancy.findIndex(x => x.id === this.valuePregnancy);
      // if (this.selectPregnancy[index].isPregnant) {
      //   this.hightLightObj.isPregnant = this.selectPregnancy[index].isPregnant;
      // }
      let i = 0;
      while (i < this.dataRow.length) {
        if (this.selectPregnancy[index].isPregnant && this.dataRow[i].isPregnantWarning) {
          this.dataRow[i].isHighLight = true;
        } else {
          this.dataRow[i].isHighLight = this.hightLightObj.hightLightArr[i].isHighLight;
        }
        i++;
      }
    } else {
      let i = 0;
      while (i < this.dataRow.length) {
        const index = this.hightLightObj.hightLightArr.findIndex(x => x.vaccineId === this.dataRow[i].vaccineId);
        if (index > -1) {
          this.dataRow[i].isHighLight = this.hightLightObj.hightLightArr[i].isHighLight;
        }
        i++;
      }
    }
  }
  contentTooltip(vaccine) {
    const medicalName = this.pregnancySelected && this.pregnancySelected.isPregnant && vaccine.isPregnantWarning ? this.pregnancySelected.name : null;
    let arr_Medical = [vaccine.medicalCondition,medicalName]; 
    arr_Medical = arr_Medical.filter(x => x !== null && x !== ''); 
    return arr_Medical.join(', ');
  }
  /**
   * @param row
   * @param event
   *  Check Valid Batch Number
   */

  onSelectBatchNumber(row, event) {   // Select Batch number in use and check valid Batch Number
    const value = event.target.value;
    // update selected value to date array
    const vaccineDate = row.vaccineDates.find(i => i.visit === this.patientVaccineVisit.Current);
    vaccineDate.batchNumber = value;
  }
  /**
   * @param row
   * @param site
   * function  checked valid site to administer
   */
  onChekedSiteToAdminister(row, site) {
    // Check Valid and get value Site to administer
    row.vaccineDates.forEach(i => {
      if (i.isChecked === true && i.visit === 1) {
        i.siteToAdministerId = site.id;
      }
    });
  }
  /**
   * check valid if next step
   */
  isValidAministerData() {
    let isValid = true;

    // Check Required field select prenancy Adminsister Vaccine if patient is female
    if (this.isFemale && (this.valuePregnancy === null || this.valuePregnancy === 'null' || this.valuePregnancy === undefined)) {
      this.dialogService.openErrorDialog({ message: AppMessages.administerVaccine.errorSelectPregnancy });
      return false;
    }
    for (let i = 0; i < this.dataRow.length; i++) {
      const dataRowValid = this.dataRow[i].vaccineDates.filter(c => c.isChecked === true && c.visit === this.patientVaccineVisit.Current);
      // Check Required field select Batch Number Adminsister Vaccine
      if (dataRowValid[0].batchNumber === null || dataRowValid[0].batchNumber === undefined || dataRowValid[0].batchNumber === 'null') {
        this.dialogService.openErrorDialog({ message: AppMessages.administerVaccine.errorBatchNumber });
        isValid = false;
        break;
      }
      // Check Required field radio checked site dminsister Vaccine
      if (dataRowValid[0].siteToAdministerId === null || dataRowValid[0].siteToAdministerId === undefined || dataRowValid[0].siteToAdministerId === 'null') {
        this.dialogService.openErrorDialog({ message: AppMessages.administerVaccine.errorSiteAdministerVaccine });
        isValid = false;
        break;
      }
    }
    // check valid propose administer vaccine date
    if (!this.isValidProposeAdministerDate()) {
      this.dialogService.openErrorDialog({ message: AppMessages.administerVaccine.errorProposeAdministerDate });
      isValid = false;
      return false;
    }
    return isValid;
  }

  isValidProposeAdministerDate() {
    let isValid = true;
    // check propose date in data entry mode
    let administerDate = null;
    let lastedAdministeredDate = null;
    if (this.isDataEntryMode) {
      this.dataRow.forEach(item => {
        item.vaccineDates.forEach((vDate, index) => {
          if (vDate.visit === PatientVaccineVisit.Current) {
            // admin Date must be the same for all vaccines
            if (!vDate.vaccinateDate || (administerDate && vDate.vaccinateDate && administerDate !== vDate.vaccinateDate)) {
              isValid = false;
            } else {
              if (!administerDate && vDate.vaccinateDate) {
                administerDate = vDate.vaccinateDate;
              }
            }
          }
        });
      });
      // save latest administered date
      if (this.prescribeVaccination.length > 0) {
        this.prescribeVaccination[0].vaccine.vaccineDates.forEach((vDate, index) => {
          if (vDate.visit === PatientVaccineVisit.Past && vDate.visitDate) {
            if (!lastedAdministeredDate || (lastedAdministeredDate && ValidationService.compareDateString(lastedAdministeredDate, vDate.visitDate) === -1)) {
              lastedAdministeredDate = vDate.visitDate;
            }
          }
        });
      }

      // if administer date after the latest administered date
      lastedAdministeredDate = this.utility.convertDateToString(lastedAdministeredDate);
      if (ValidationService.compareDateString(administerDate, lastedAdministeredDate) === -1) {
        isValid = false;
      }
    }
    return isValid;
  }

  /**
   * save data when user click on next step
   */
  submitData() {

    if (this.isValidAministerData()) {
      // popup confirm
      this.dialogService.openComponentDialog(AdministerVaccinePopupComponent, {}, { 'width': '400px' }).subscribe(
        (result) => {
          if (result) {
            // submit success
            this.administerVaccineService.updateAdministerVaccine(this.filterParam.id, this.prescribeVaccination, this.valuePregnancy, this.isMoveNextStep).subscribe(
              (result1) => {
                this.navigateAction();
              },
              (error) => {
                if (error.status === 400) {
                  const errMsg = error.json();
                  this.dialogService.openErrorDialog({ message: errMsg.message }).subscribe(
                    (dialogResult) => {
                      if (dialogResult && errMsg.hasOwnProperty('isRefresh')) {
                        if (errMsg['isRefresh']) {
                          // refresh page : UC100 2.24
                          this.consultationProcessService.getPatientData(this.filterParam.patientId).subscribe(
                            (patientResult) => {
                              if (patientResult) {
                                const patientDetail = patientResult.json();
                                this.initPrenancyData(patientDetail.sexId);
                              }
                            }
                          );
                        }
                      }
                    });
                }
              });
          }
        });
    }
  }

  /**
   * return row class if item isCovered
   * @param row
   */
  getRowClass(row) {
    return {
      'covered': row.isCovered === true
    };
  }

  /**
   * fill Proposed admin date incase user is in data entry mode
   */
  onDoAChange(event, row) {
    if (event) {
      row['vaccineDates'].forEach(visitDate => {
        if (visitDate['date'] && visitDate['visit'] === PatientVaccineVisit.Current) {
          visitDate['vaccinateDate'] = this.utility.convertDateToString(event);
        }
      });
    }
  }

  /**
  * update isDataEntryMode flag
  * @param dataEntryMode : 0/1
  */
  updateDataEntryMode(dataEntryMode) {
    this.isDataEntryMode = (dataEntryMode === 1) ? true : false;
    this.updateTableLayout();
    this.updateProposeAdministerDate();
  }

  addNewBatch(row) {
    const param = {
      vaccineId: row.vaccineId,
      centreId: localStorage.getItem(this.appConstants.localStorage.centreId),
      saveAndAddOther: false
    };
    this.dialogService.openComponentDialog(ManageVaccineAddPopupComponent, param).subscribe(result => {
      if (result) {
        if (this.dataRow.length) {
          let i = 0;
          while (i < this.dataRow.length) {
            if (this.dataRow[i].vaccineId === result['vaccineId']) {
              if (Array.isArray(this.dataRow[i].batchs)) {
                this.dataRow[i].batchs.push(result['batch']);
              } else {
                this.dataRow[i].batchs = new Array();
                this.dataRow[i].batchs.push(result['batch']);
              }
            }
            i++;
          }
        }
      }
    });
  }

  /**
   * in data entry mode :update vaccinateDate to current date
   * in normal mode: update vaccinateDate to null
   */
  updateProposeAdministerDate() {
    this.dataRow.forEach(item => {
      item.vaccineDates.forEach(date => {
        if (date.visit === PatientVaccineVisit.Current) {
          if (this.isDataEntryMode) {
            date.vaccinateDate = this.utility.convertDateToUTCString(this.currentDate);
          } else {
            date.vaccinateDate = null;
          }
        }
      });
    });
  }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/administer-vaccine/administer-vaccine.component.ts